import React, { useEffect } from "react";
import ReportUtils from "../../../../../utils/report-utils.js";
import InnerDetails from "../../../../../components/reports/Inner-details.jsx";

const ReportContent = ({ data, searchDetails, tableColumns }) => {
    useEffect(() => {
        ReportUtils.createExportableTable(null, null, "SLA dos smartcaptures", "sla-collection-point",);
    }, [data, tableColumns]);

    if (!data) return null;

    const columns = [
        { id: "device", render: (item) => item.smartname },
        { id: "pin", render: (item) => item.pin },
        { id: "sla", render: (item) => item.sla_network_on },
        { id: "inactive", className: "text-right", render: (item) => item.sla_network_off},
        { id: "events", className: "text-center", render: (item) => item.events.length ?? ""},
    ];

    const visibleColumns = columns.filter(
        (column) => tableColumns?.[column.id]?.visible !== false,
    );

    return (
        <>
            {visibleColumns.length ? (
                <table id="sla-collection-point" className="table report-table" sheet-name="SLA dos smartcaptures">
                    <thead className="thead-background">
                        <tr className="bg-[#f6f6f6] text-left">
                            {visibleColumns.map((column) => (
                                <th key={column.id} className={column.className}>
                                    {tableColumns[column.id].label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {data.map((item, index) => (
                            <React.Fragment key={index}>
                            <tr className={`table-break-word ${searchDetails ? "details-row" : ""}`}>
                                    {visibleColumns.map((column) => (
                                        <td key={column.id} className={column.className}>
                                            {column.render(item)}
                                        </td>
                                    ))}
                                </tr>

                                <InnerDetails searchDetails={searchDetails} events={item.events} colSpan={visibleColumns.length}/>
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            ) : (
            <div id="noDataMessage" className="alert alert-info p-2 h6 text-center">
                    Todas as colunas foram ocultadas.
                </div>
            )}

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;